module.exports = __webpack_public_path__ + "static/group-image-e3bc345d855e9fe729eb47bf9af6dafe.png";